var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-alert",class:_vm.getClasses},[_c('p',{staticClass:"c-alert__title"},[_vm._v(_vm._s(_vm.alert.title))]),_vm._v(" "),_c('p',{staticClass:"c-alert__content",domProps:{"innerHTML":_vm._s(_vm.alert.body)}}),_vm._v(" "),_c('button',{staticClass:"c-alert__close",on:{"click":_vm.close}})])
}
var staticRenderFns = []

export { render, staticRenderFns }